<template>
  <section class="vbox">
    <section class="scrollable wrapper">
      <div class="content-header">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>营销</el-breadcrumb-item>
          <el-breadcrumb-item>拼团</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content-main">
        <el-form :inline="true">       
          <el-form-item label="主题类型" >
            <el-select v-model="queryParam.subject" size="small" placeholder="请选择主题类型">
              <el-option label="促销活动" value="1"></el-option>
              <el-option label="热门主题" value="2"></el-option>
              <el-option label="精选榜单" value="3"></el-option>
              <el-option label="行业频道" value="4"></el-option>
              <el-option label=" 其他" value="5"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="物料类型" >
            <el-select v-model="queryParam.materialType" size="small" placeholder="请选择物料类型">
              <el-option label="商品" value="1"></el-option>
              <el-option label="权益" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" v-on:click="Search" >查询</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="items" style="width: 100%">
          <el-table-column  prop="materialName" label="标题" width="200px"> </el-table-column>
          <el-table-column  prop="materialId" label="物料id"> </el-table-column>
          <el-table-column  prop="materialType"  label="状态" > 
            <template slot-scope="scope">                    
              <p v-if="scope.row.materialType=='1'">商品</p>
              <p v-if="scope.row.materialType=='2'">权限</p>
            </template>
          </el-table-column>
          <el-table-column  prop="subject"  label="主题类型" > 
            <template slot-scope="scope">                    
              <p v-if="scope.row.subject=='1'">促销活动</p>
              <p v-if="scope.row.subject=='2'">热门主题</p>
              <p v-if="scope.row.subject=='3'">精选榜单</p>
              <p v-if="scope.row.subject=='4'">行业频道</p>
              <p v-if="scope.row.subject=='5'">其他</p>
            </template>
          </el-table-column> 
          <el-table-column  prop="startTime" :formatter="dateFormat"  label="开始时间"></el-table-column>
          <el-table-column  prop="endTime" :formatter="dateFormat"  label="结束时间"></el-table-column>
                 
        </el-table>
        <el-pagination
          :hide-on-single-page="true"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParam.pageIndex"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryParam.pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="queryParam.totalCount">
        </el-pagination>
      </div>   
    </section> 
  </section>
</template>
<script  type='text/ecmascript-6'>
  import { parseTime } from '@/utils/date'
  export default {
    props:{
    },
    data (){
      return {        
        items:[],
        queryParam:{
          subject:'1',
          materialType:'1',
          pageIndex:1,
          pagesize:10,
          totalCount:10,
        }
      }
    },
    computed:{
    },
    mounted(){
      this.GetData();
    },
    methods:{     
      Search:function(){
        this.queryParam.pageIndex = 1;
        this.GetData();
      },
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/TaoBao/MaterialList',
          params: that.queryParam
        }).then(function (resp) {
          that.queryParam.totalCount = resp.data.totalCount
          that.items = resp.data.rows
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      dateFormat:function(row, column, cellValue, index){
	      return  parseTime(cellValue, '{y}-{m}-{d}')
      },    
      handleSizeChange(val) {
        this.queryParam.pagesize =  val
        this.queryParam.pageIndex = 1
        this.GetData()
      },
      handleCurrentChange(val) {
        this.queryParam.pageIndex = val
        this.GetData()
      }
    },
    components:{    
       
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
</style>